/**
 * .modal-upload
 * Pass the variables to modal window
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    // Attach the contextual behaviour to the #upload modal
    $('#upload').on('show.bs.modal', function (event)
    {
        // Button that triggered the modal
        var button = $(event.relatedTarget)
        var modal  = $(this)

        // Extract info from data-* attributes
        var contexts       = button.data('contexts') || {} ;
        var context_type   = button.data('context-type') || '';
        var context_id     = parseInt(button.data('context-id')) || '';
        var reference_name = button.data('selected-reference-name') || '';

        // If necessary, we can initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content.
        // We'll use jQuery here.
        // set the action on the form
        modal.find('input[name="context_id"]').val(context_id)
        modal.find('input[name="context_type"]').val(context_type)
        modal.find('input[name="contexts"]').val( JSON.stringify(contexts))

        if (modal.find('select[name="reference_name"]').length && reference_name){
            modal.find('select[name="reference_name"]').val(reference_name);
        } else if (reference_name) {
            modal.find('input[name="reference_name"]').val(reference_name)
        }
    });
});
